import React from "react"
import { type RouteObject } from "react-router-dom"

import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../../constants/routes.ts"
import SuppliersPage from "../../../SuppliersPage/SuppliersPage.tsx"
import SupplierDetailPage from "../../../SuppliersPage/SupplierDetailPage"

export const supplierRoutes: RouteObject[] = [
  {
    path: RoutesPaths.suppliers.list,
    element: (
      <PermissionGate pages={["suppliers"]}>
        <SuppliersPage />
      </PermissionGate>
    )
  },
  {
    path: RoutesPaths.suppliers.view(":id"),
    element: (
      <PermissionGate pages={["suppliers"]}>
        <SupplierDetailPage />
      </PermissionGate>
    )
  }
]
